
const fetchSchools = () => {
  return new Promise(function(resolve, reject) {
    reject("fetchSchools API NOT IMPLEMENTED");
  });
};

export default { fetchSchools }
